import React from 'react';

function SvgArrowRightNarrow(props) {
  return (
    <svg
      width="62"
      height="11"
      viewBox="0 0 62 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54.0726 1.0842C53.8714 1.11031 53.7121 1.21783 53.6555 1.35915C53.5989 1.50354 53.6576 1.6556 53.8043 1.75698L58.7048 5.34822L42.9552 5.34822C42.9384 5.34822 2.0061 5.33901 1.98933 5.33901C1.69589 5.34822 1.46532 5.53255 1.47999 5.74759C1.49467 5.96264 1.7441 6.13006 2.03964 6.11931L58.7048 6.12853L53.8043 9.71977C53.6471 9.815 53.5737 9.96554 53.6198 10.113C53.6659 10.2574 53.821 10.3726 54.0202 10.4064C54.2193 10.4402 54.4268 10.3864 54.5547 10.2697L60.3712 6.01947L60.738 5.73838L60.3712 5.45728L54.5547 1.20708C54.4436 1.11953 54.2843 1.07498 54.1208 1.0842C54.104 1.0842 54.0893 1.0842 54.0726 1.0842Z"
        fill={props.color || 'black'}
        stroke={props.color || 'black'}
      />
    </svg>
  );
}

export default SvgArrowRightNarrow;
